module.exports = __webpack_public_path__ + "static/amy-dance-385d529d75428b4d08825d6ef10bd591.gif";